import React from 'react'

const Required = () => {
  return <span className="text-danger">*</span>
}

export default Required
